import { useCallback } from "react";
import { Button } from "../../../../externalComponents/tailwind/button";
import { Dialog, DialogActions, DialogBody, DialogTitle } from "../../../../externalComponents/tailwind/dialog";

const SendNowDialog = ({ modalRef, setModalRef, sendCampaign }) => {

  const handleClose = useCallback((event) => {

    setModalRef(_modalRef => ({
      ..._modalRef,
      sendNow: false,
    }));
    if (event) {
      sendCampaign();
    }
  }, [modalRef.sendNow]);

  return <Dialog open={modalRef.sendNow} onClose={() => handleClose(false)} >
    <DialogTitle>Send now</DialogTitle>
    <DialogBody>
      Your campaign will be sent now to the selected contacts. Are you sure you want to proceed?
    </DialogBody>
    <DialogActions>
      <Button color="secondaryButton" className="min-w-[100px] h-10" onClick={() => handleClose(false)}      >
        Cancel
      </Button>
      <Button color="primaryButton" className="min-w-[100px] h-10" onClick={() => handleClose(true)}>
        Send now
      </Button>
    </DialogActions>
  </Dialog >;

}

export default SendNowDialog;
